import React from 'react';
import '../Style/components.css';
export default function Terminal(props) {
  const fireCommand = (val) => {
    props.fire_command({
      ...props.terminal,
      command: val,
      prompt: '',
      fire: true,
    });
  };
  return (
    <div
      className="terminal"
      style={
        props.show
          ? {
              display: 'block',
            }
          : { display: 'none' }
      }
    >
      TERMINAL
      <textarea
        id="cmd"
        readOnly
        className="console"
        value={props.terminal.command}
      ></textarea>
      <input
        className="console-cmd"
        value={props.terminal.prompt}
        onChange={(e) =>
          props.fire_command({
            ...props.terminal,
            prompt: e.target.value,
          })
        }
        onKeyDown={(e) =>
          e.key === 'Enter' ? fireCommand(e.target.value) : null
        }
      />
    </div>
  );
}
